// ============================================================
// VCS.init() — Einziger Startpunkt der Anwendung
// ============================================================
// Wird als letzte Datei geladen. Instanziiert alle Klassen,
// ruft init() auf und stellt die WebSocket-Verbindung her.
// ============================================================

// Bootstrap-Daten aus JSON-Block (CSP-konform, ersetzt frueher inline scripts).
(function () {
    var el = document.getElementById('bootstrap-data');
    if (!el) {
        return;
    }
    try {
        var data = JSON.parse(el.textContent);
        window.DATA_EPOCH = data.dataEpoch || '1';
        window.VAPID_PUBLIC_KEY = data.vapidPublicKey || '';
    } catch (e) {
        console.error('[bootstrap] JSON parse failed:', e);
    }
})();

// Globaler Form-Submit-Handler: ersetzt frueher inline onsubmit="return false".
// Greift fuer alle <form data-no-submit> im Messenger.
document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[data-no-submit]')) {
        e.preventDefault();
    }
});

// iceRestart-Button: ersetzt frueher inline onclick="VCS.webrtc?.iceRestart()".
document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('netQualityReconnect');
    if (btn) {
        btn.addEventListener('click', function () {
            if (VCS.webrtc && typeof VCS.webrtc.iceRestart === 'function') {
                VCS.webrtc.iceRestart();
            }
        });
    }
});

window.VCS = window.VCS || {};

VCS.SCRIPT_VERSION = '1.1.1';

// ============================================================
// Einladungslink: eingehendes ?i=<token>
// ============================================================
// Der Token kommt auf zwei Wegen hier an:
//   a) direkt, wenn jemand mit bestehendem Konto /i/<token> oeffnet und
//      auf messenger.bernoria.com/?i=<token> landet,
//   b) angehaengt an die Handoff-URL, wenn sich jemand ueber den Link neu
//      registriert hat (account.js haengt &i= an).
//
// Eingeloest wird NICHT hier, sondern erst nach 'chat-authed' -- vorher gibt
// es keine Session, gegen die /invite/redeem laufen koennte. Bis dahin liegt
// der Token im localStorage: Wer den Messenger ohne Konto oeffnet, registriert
// sich erst noch, und der Link muss diesen Umweg ueberleben.
//
// MUSS vor handleHandoffParam() laufen: das raeumt die komplette Query per
// history.replaceState ab und wuerde ?i= mit wegwerfen.
const INVITE_STORE_KEY  = 'pending-invite-token';
const INVITE_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // Server-TTL des Links
const INVITE_TOKEN_RE   = /^[A-Za-z0-9_-]{16,64}$/;

function captureInviteParam() {
    const token = new URLSearchParams(window.location.search).get('i');
    if (!token || !INVITE_TOKEN_RE.test(token)) return;

    try {
        localStorage.setItem(INVITE_STORE_KEY, JSON.stringify({ token: token, ts: Date.now() }));
        console.log('[invite] token captured token=' + token.slice(0, 6));
    } catch (e) {
        console.warn('[invite] could not store token:', e?.message);
    }

    // Aus der URL nehmen, damit ein Reload den Einloese-Versuch nicht wiederholt
    // und der Token nicht in Screenshots oder im Verlauf haengen bleibt. Den
    // handoff-Parameter fasst diese Funktion nicht an -- den raeumt
    // handleHandoffParam() gleich selbst ab.
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete('i');
        history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (_) {}
}

// Liefert den gemerkten Token oder null. Raeumt abgelaufene Eintraege weg --
// ein Link, der laenger liegt als der Server ihn kennt, kann nur noch scheitern.
VCS.getPendingInviteToken = function () {
    let raw = null;
    try {
        raw = localStorage.getItem(INVITE_STORE_KEY);
    } catch (_) {
        return null;
    }
    if (!raw) return null;

    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (_) {
        VCS.clearPendingInviteToken();
        return null;
    }
    if (!parsed?.token || !INVITE_TOKEN_RE.test(parsed.token)) {
        VCS.clearPendingInviteToken();
        return null;
    }
    if (!parsed.ts || (Date.now() - parsed.ts) > INVITE_MAX_AGE_MS) {
        console.log('[invite] stored token expired locally, dropping');
        VCS.clearPendingInviteToken();
        return null;
    }
    return parsed.token;
};

VCS.clearPendingInviteToken = function () {
    try {
        localStorage.removeItem(INVITE_STORE_KEY);
    } catch (_) {}
};

// ============================================================
// Web-reg handoff: incoming ?handoff=<token> from www.bernoria.com
// ============================================================
// Flow (see spec web-reg-handoff):
//   1. www.bernoria.com /account.php verifies the phone, then calls
//      POST /auth/handoff-create which returns a single-use token.
//   2. www redirects to messenger.bernoria.com/?handoff=<token>.
//   3. Here on the messenger we exchange the token for {sessionToken, password, phone}
//      via POST /auth/handoff-consume (single-use, server-side TTL 5 min).
//   4. We persist the session like a normal login and seed E2E with the password
//      (handleKeySetup -- generates a key pair and an encrypted backup, password is the
//       wrapping key). The same password used for the web account is now also the E2E
//       password -- a second-device login with email+password later restores E2E
//       cleanly (memory project_krypto_key_wrapping.md).
//   5. We strip ?handoff from the URL via history.replaceState BEFORE handleKeySetup
//      runs, so that even if E2E setup throws, the token is gone from history/clipboard.
//   6. The password variable is overwritten with empty string after handleKeySetup
//      returns, never logged, never put on window.
//
// On failure (410 handoff_expired / network): toast + redirect back to web login.
async function handleHandoffParam() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('handoff');
    if (!token) return false;

    // strip ?handoff from URL immediately (before any await) so the token does not
    // leak into back/forward navigation, history snapshots or shared screenshots.
    try {
        history.replaceState(null, '', window.location.pathname);
    } catch (_) {}

    let payload = null;
    let pw = '';
    try {
        const res = await fetch('/api/auth/handoff-consume', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token })
        });

        if (res.status === 410) {
            console.warn('[handoff] expired or already consumed');
            window.location.href = 'https://www.bernoria.com/login.php?reason=handoff_expired';
            return false;
        }
        if (!res.ok) {
            console.error('[handoff] /auth/handoff-consume failed status=' + res.status);
            window.location.href = 'https://www.bernoria.com/login.php?reason=handoff_expired';
            return false;
        }

        payload = await res.json();
        if (!payload || !payload.ok || !payload.sessionToken || !payload.phone) {
            console.error('[handoff] response missing required fields');
            window.location.href = 'https://www.bernoria.com/login.php?reason=handoff_expired';
            return false;
        }
        pw = payload.password || '';
    } catch (e) {
        console.error('[handoff] network/parse error:', e && e.message ? e.message : 'unknown');
        window.location.href = 'https://www.bernoria.com/login.php?reason=handoff_expired';
        return false;
    }

    const phone = payload.phone;
    const sessionToken = payload.sessionToken;

    // Persist session analog to chat-setup login path (chat-setup.js:349-355).
    try {
        VCS.state = VCS.state || {};
        VCS.state.chatMyPhone = phone;
        VCS.state.chatAuthToken = sessionToken;
        localStorage.setItem('chat-auth-token', sessionToken);
        localStorage.setItem('chat-phone', phone);
        // chatRegistered is the gate for app-shell visibility and SW push registration.
        VCS.state.chatRegistered = true;
    } catch (e) {
        console.error('[handoff] localStorage write failed:', e && e.message ? e.message : 'unknown');
    }

    // Pull display name + plan from /auth/me so the messenger UI is complete.
    // Failure here is non-fatal -- the user just sees "—" until next sync.
    try {
        const meRes = await fetch('/api/auth/me', {
            credentials: 'include',
            headers: { 'Authorization': 'Bearer ' + sessionToken }
        });
        if (meRes.ok) {
            const meData = await meRes.json();
            const u = meData && meData.user;
            if (u) {
                if (u.displayName) {
                    VCS.state.chatMyName = u.displayName;
                    localStorage.setItem('chat-name', u.displayName);
                }
                if (u.plan) {
                    VCS.state.chatMyPlan = u.plan;
                    localStorage.setItem('chat-plan', u.plan);
                }
                if (u.trialEndsAt) {
                    VCS.state.chatTrialEndsAt = u.trialEndsAt;
                    localStorage.setItem('chat-trial-ends-at', String(u.trialEndsAt));
                }
            }
        } else {
            console.warn('[handoff] /auth/me returned status=' + meRes.status);
        }
    } catch (e) {
        console.warn('[handoff] /auth/me failed:', e && e.message ? e.message : 'unknown');
    }

    console.log('[handoff] consume OK phone=' + (phone || '').slice(0, 4) + '*** session=' + sessionToken.slice(0, 8));
    return { phone: phone, password: pw };
}

// ── Instanziierung + Init ───────────────────────────────────

(async () => {

    // Phase 1: Basis-Module (kein DOM nötig)
    VCS.i18n         = new VCS.I18n();
    VCS.netStats     = new VCS.NetStats();
    VCS.audioMonitor = new VCS.AudioMonitor();
    VCS.notify       = new VCS.Notify();

    // Phase 2: State-abhängige Module
    VCS.ui           = new VCS.UI();
    VCS.nav          = new VCS.Nav();
    VCS.session      = new VCS.Session();
    VCS.e2e          = new VCS.E2E();
    VCS.deviceLink   = new VCS.DeviceLink();
    VCS.mediaCache   = new VCS.MediaCache();
    VCS.media        = new VCS.Media();
    VCS.blur         = new VCS.Blur();
    VCS.captions     = new VCS.Captions();

    // Phase 3: Chat-Module
    VCS.chat            = new VCS.Chat();
    VCS.chatSetup       = new VCS.ChatSetup();
    VCS.chatContacts    = new VCS.ChatContacts();
    VCS.chatGroups      = new VCS.ChatGroups();
    VCS.chatPresence    = new VCS.ChatPresence();
    VCS.chatRecordingUI = new VCS.ChatRecordingUI();
    VCS.chatVoice       = new VCS.ChatVoice();
    VCS.chatVideo       = new VCS.ChatVideo();
    VCS.chatPhoto       = new VCS.ChatPhoto();
    VCS.chatMedia        = new VCS.ChatMedia();
    VCS.chatMediaGallery = new VCS.ChatMediaGallery();
    VCS.chatMessages     = new VCS.ChatMessages();

    // Phase 3b: Dating-Module (VCS.dating = UI/Screen, VCS.datingCore = REST)
    VCS.datingCore    = new VCS.DatingCore();
    VCS.datingGeo     = new VCS.DatingGeo();
    VCS.datingProfile = new VCS.DatingProfile();
    VCS.datingDeck    = new VCS.DatingDeck();
    VCS.datingRadar   = new VCS.DatingRadar();
    VCS.datingFindme  = new VCS.DatingFindme();
    VCS.dating        = new VCS.DatingUi();

    // Phase 4: Signaling, WebRTC, CallControls, CallHistory
    VCS.signaling    = new VCS.Signaling();
    VCS.webrtc       = new VCS.WebRTC();
    VCS.callControls = new VCS.CallControls();
    VCS.callHistory  = new VCS.CallHistory();
    // VCS.liveConvo wird als Singleton am Ende von live-convo.js instanziiert
    // (analog VCS.audioFader). init() weiter unten.

    // ── Web-reg handoff: token gegen Session+PW tauschen ─────
    // Muss VOR init() laufen, damit chat-setup.updateRegistrationUI() bereits
    // registered=true sieht und die Reg-Karte gar nicht erst zeigt.
    // handleKeySetup folgt spaeter, nachdem VCS.e2e.init() lief.
    // Einladungslink zuerst sichern -- handleHandoffParam() raeumt die Query ab.
    captureInviteParam();

    let __handoffSeed = null;
    if (window.location.search.indexOf('handoff=') !== -1) {
        __handoffSeed = await handleHandoffParam();
    }

    // ── Translations laden (vor allen init()-Aufrufen) ────────
    // loadTranslations() ist global (aus translations.js)
    await loadTranslations();

    // ── init() aller Module aufrufen ─────────────────────────
    // Reihenfolge: Basis → UI → Session → Captions → Chat → Controls → Signaling

    VCS.i18n.init();
    VCS.ui.init();                  // Theme, Tooltips, StaticIcons
    VCS.audioMonitor.init();        // Audio-Unlock
    VCS.notify.init();              // ServiceWorker, InstallUX, Push
    VCS.session.init();             // Storage-Migrations, Room-ID
    VCS.session.restoreUI();        // Session wiederherstellen, Rejoin
    VCS.nav.init();                 // Desktop/Mobile Layout-Wechsel
    VCS.e2e.init();
    VCS.deviceLink.init();          // QR-Login: Buttons/Overlays verdrahten

    // Handoff-E2E-Setup: Keypair generieren + Backup mit Web-PW als Wrapping-Key.
    // Web-PW == E2E-PW (memory project_krypto_key_wrapping.md). Damit kann sich der
    // User spaeter auf einem zweiten Geraet mit Mail+PW einloggen und das Backup
    // entschluesseln. handleKeySetup ist idempotent (siehe e2e.js handleKeySetup).
    if (__handoffSeed && __handoffSeed.phone && __handoffSeed.password) {
        try {
            // existing=false (kein Restore-Flow; frischer Web-Reg-Account),
            // serverHasBackup=false (Server hat fuer einen frisch-registrierten Account
            // kein Backup; handleKeySetup checkt zur Sicherheit selbst nach).
            await VCS.e2e.handleKeySetup(__handoffSeed.phone, __handoffSeed.password, false, false);
        } catch (e) {
            console.error('[handoff] handleKeySetup failed:', e && e.message ? e.message : 'unknown');
        } finally {
            // PW aus Speicher loeschen -- weder Logs noch window noch Closures sollen
            // den Klartext halten. JS kann das nur best effort, aber wir helfen GC.
            __handoffSeed.password = '';
            __handoffSeed = null;
        }

        // Post-handoff parity with the normal reg flow (chat-setup.js:121-122):
        // a freshly web-registered user is always new + in trial, so we mirror
        // the welcome overlay + bot chat triggers here. Without this the user
        // landed silently on the chat list -- no onboarding, no bot chat.
        const trialEndsAt = VCS.state.chatTrialEndsAt || 0;
        if (trialEndsAt && Date.now() < trialEndsAt) {
            setTimeout(() => VCS.chatSetup?.showWelcomeOverlay?.(), 500);
        } else {
            // Fallback if trialEndsAt is missing (older /auth/me responses):
            // at least prompt for notifications, like the reg flow does.
            setTimeout(() => VCS.notify?.promptAfterRegistration?.(), 800);
        }
        // Bot chat: idempotent. loadChats() also calls this after chat-authed,
        // but a direct call here protects against ordering races where the user
        // briefly sees an empty list. _ensureBotChat checks the concierge right itself.
        VCS.chatSetup?._ensureBotChat?.();
    }

    await VCS.mediaCache.init();
    VCS.media.init();
    VCS.blur.init();
    VCS.netStats.init();
    VCS.captions.init();
    VCS.audioFader?.init();         // translated-audio playback + slider UI
    VCS.liveConvo?.init();          // Live-Unterhaltung (Solo-Dolmetscher)
    VCS.interpretRoom?.init();      // Dolmetscher mit Partner-Geraet (nach liveConvo: haengt Knopf in dessen Dialog)
    VCS.liveCapNotice?.init();      // Minuten-Warnung + Nachkauf im Gespraech
    VCS.guestInvite?.init();        // Gast-Anruf: Link erzeugen, Klopfen beantworten

    VCS.chat.init();
    VCS.chatSetup.init();
    // Auth-Token gegen /auth/me validieren (fire-and-forget). Bei 401/403 invalidiert
    // chatSetup.validateAuthToken den lokalen Login und reloadet die Seite.
    VCS.chatSetup.validateAuthToken();
    VCS.chatContacts.init();
    VCS.chatGroups.init();
    VCS.chatPresence.init();
    VCS.chatRecordingUI.init();
    VCS.chatVoice.init();
    VCS.chatVideo.init();
    VCS.chatPhoto.init();
    VCS.chatMedia.init();
    VCS.chatMediaGallery.init();
    VCS.chatMessages.init();

    VCS.datingCore.init();
    VCS.datingGeo.init();           // Dating: Geohash, Position
    VCS.datingProfile.init();       // Dating: Profil-Formular + Fotos
    VCS.datingDeck.init();          // Dating: Kartenstapel, Wischen, Match
    VCS.datingRadar.init();         // Dating: Radar-Canvas
    VCS.dating.init();              // Dating: Screen, Startseite, View-Wechsel

    VCS.callControls.init();        // Call-, PreJoin-, Waiting-Controls, Drag
    VCS.callHistory.init();         // Anrufliste
    VCS.signaling.init();
    VCS.webrtc.init();

    // ── Preview starten ──────────────────────────────────────
    // (Video-Tab wurde entfernt — Preview wird nicht mehr beim Start benötigt)

    // ── Pre-Render Account-Verify ────────────────────────────
    // Before we open the WebSocket and render cached data, make sure the
    // server still knows the account this token belongs to. If it does not
    // (e.g. another device deleted/re-registered while we were offline),
    // verifyAccountStillExists() wipes local state and reloads -- the lines
    // below will not run in that case.
    const accountOk = await VCS.chatSetup.verifyAccountStillExists();
    if (!accountOk) return;

    // ── WebSocket-Verbindung herstellen ──────────────────────
    VCS.signaling.connect();

    // ── Notification-Prompt beim App-Start ───────────────────
    if (VCS.state.chatRegistered) {
        setTimeout(() => VCS.notify?.promptOnAppStart(), 1500);
    }

})();
